import { useEffect } from "react";
import { Route, Routes } from "react-router-dom";
import { setDocumentTitle } from "@/lib/documentTitle";

import { C5PortfoliosEdit } from "./edit";
import { C5PortfoliosNew } from "./new";
import { C5PortfoliosTable } from "./table";
export default function C5Portfolios() {
  useEffect(() => {
    setDocumentTitle("Quantilia | Portefeuilles");
  }, []);

  return (
    <Routes>
      <Route path=":id" element={<C5PortfoliosEdit />} />
      <Route index element={<C5PortfoliosTable />} />
      <Route path="/new" element={<C5PortfoliosNew />} />
    </Routes>
  );
}
